import React from "react";
import {Dictionary} from "../Dictionary";

export class DateTime extends React.Component<any, any> {
    private dictionary: Dictionary = new Dictionary();

    static create(props: any) {
        return (
            <DateTime {...props}/>
        );
    }

    static atom(value: any): string {
        const dictionary: Dictionary = new Dictionary();
        const date = new Date(value);
        // let date = (new Date(value)).toLocaleDateString(dictionary.getLocale(), {
        //     year: 'numeric',
        //     month: '2-digit',
        //     day: '2-digit',
        // });
        let time = (new Date(value)).toLocaleTimeString(dictionary.getLocale(), {
            hour: '2-digit',
            minute: '2-digit'
        });
        const month: string = ((9 < (date.getMonth() + 1)) ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)).toString();
        const day: string = ((9 < date.getDate()) ? date.getDate() : '0' + date.getDate()).toString();
        return date.getFullYear() + '-' + month + '-' + day + 'T' + time;
    }

    render() {
        let value = this.props?.value;

        if (value) {
            value = 20 < value.length ? value : value + ' GMT';
        }

        if (value) {
            let date = (new Date(value)).toLocaleDateString(this.dictionary.getLocale(), {
                year: 'numeric',
                // month: 'short',
                month: '2-digit',
                day: '2-digit',
            });
            let time = (new Date(value)).toLocaleTimeString(this.dictionary.getLocale(), {
                hour: '2-digit',
                minute: '2-digit'
            });

            if (this.props.onlydate) {
                return (
                    <>{date}</>
                );
            }

            if (this.props?.inline) {
                return (
                    <>{date} {time}</>
                );
            }
            return (
                <>{date}<br/>{time}</>
            );
        }

        return this.props?.empty || '-';
    }
}